import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { isSome as t } from "../../../core/maybe.js";
import { b as e, c as r, r as s, j as i, m as a } from "../../../chunks/mat3.js";
import { c as o } from "../../../chunks/mat3f32.js";
import { f as u } from "../../../chunks/vec2f32.js";
import { extractBands as n } from "../../../layers/support/rasterFunctions/pixelUtils.js";
import { DisplayObject as l } from "./DisplayObject.js";
import { createTransformTexture as h, createRasterTexture as d, createColormapTexture as _ } from "../../webgl/rasterUtils.js";
var m = {
  bandCount: 3,
  outMin: 0,
  outMax: 1,
  minCutOff: [0, 0, 0],
  maxCutOff: [255, 255, 255],
  factor: [1 / 255, 1 / 255, 1 / 255],
  useGamma: !1,
  gamma: [1, 1, 1],
  gammaCorrection: [1, 1, 1],
  colormap: null,
  colormapOffset: null,
  stretchType: "none",
  type: "stretch"
};

var x = /*#__PURE__*/function (_l) {
  _inherits(x, _l);

  var _super = _createSuper(x);

  function x() {
    var _this;

    var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var e = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var r = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    _classCallCheck(this, x);

    _this = _super.call(this), _this._textureInvalidated = !0, _this._colormapTextureInvalidated = !0, _this._supportsBilinearTexture = !0, _this.stencilRef = 0, _this.coordScale = [1, 1], _this._symbolizerParameters = null, _this.height = null, _this.isRendereredSource = !1, _this.pixelRatio = 1, _this.resolution = 0, _this.rotation = 0, _this._source = null, _this.rawPixelData = null, _this._suspended = !1, _this._bandIds = null, _this._interpolation = null, _this._transformGrid = null, _this.width = null, _this.x = 0, _this.y = 0, _this.source = t, _this.transformGrid = e, _this.interpolation = r;
    return _this;
  }

  _createClass(x, [{
    key: "destroy",
    value: function destroy() {
      var t = this.getTextures();
      null == t || t.textures.forEach(function (t) {
        return t.dispose();
      }), this._rasterTexture = null, this._transformGridTexture = null, this._colormapTexture = null;
    }
  }, {
    key: "symbolizerParameters",
    get: function get() {
      return this._symbolizerParameters || m;
    },
    set: function set(t) {
      this._symbolizerParameters !== t && (this._symbolizerParameters = t, this._colormapTextureInvalidated = !0);
    }
  }, {
    key: "source",
    get: function get() {
      return this._source;
    },
    set: function set(t) {
      this._source !== t && (this._source = t, this._rasterTexture && (this._rasterTexture.dispose(), this._rasterTexture = null, this._rasterTextureBandIds = null), this.invalidateTexture());
    }
  }, {
    key: "suspended",
    get: function get() {
      return this._suspended;
    },
    set: function set(t) {
      this._suspended && !t && this.stage && (this.ready(), this.requestRender()), this._suspended = t;
    }
  }, {
    key: "bandIds",
    get: function get() {
      return this._bandIds;
    },
    set: function set(t) {
      this._bandIds = t, this._isBandIdschanged(t) && this.invalidateTexture();
    }
  }, {
    key: "interpolation",
    get: function get() {
      return this._interpolation || "nearest";
    },
    set: function set(t) {
      this._interpolation = t, this._rasterTexture && this._rasterTexture.setSamplingMode("bilinear" === this._getTextureSamplingMethod(t) ? 9729 : 9728);
    }
  }, {
    key: "transformGrid",
    get: function get() {
      return this._transformGrid;
    },
    set: function set(t) {
      this._transformGrid = t, this._transformGridTexture && (this._transformGridTexture.dispose(), this._transformGridTexture = null);
    }
  }, {
    key: "invalidateTexture",
    value: function invalidateTexture() {
      this._textureInvalidated || (this._textureInvalidated = !0, this.requestRender());
    }
  }, {
    key: "_createTransforms",
    value: function _createTransforms() {
      return {
        dvs: o()
      };
    }
  }, {
    key: "setTransform",
    value: function setTransform(t) {
      var o = e(this.transforms.dvs),
          _t$toScreenNoRotation = t.toScreenNoRotation([0, 0], [this.x, this.y]),
          _t$toScreenNoRotation2 = _slicedToArray(_t$toScreenNoRotation, 2),
          n = _t$toScreenNoRotation2[0],
          l = _t$toScreenNoRotation2[1],
          h = this.resolution / this.pixelRatio / t.resolution,
          d = h * this.width,
          _ = h * this.height,
          m = Math.PI * this.rotation / 180;

      r(o, o, u(n, l)), r(o, o, u(d / 2, _ / 2)), s(o, o, -m), r(o, o, u(-d / 2, -_ / 2)), i(o, o, u(d, _)), a(this.transforms.dvs, t.displayViewMat3, o);
    }
  }, {
    key: "getTextures",
    value: function getTextures() {
      if (!this._rasterTexture) return null;
      var t = [],
          e = [];
      return this._transformGridTexture && (e.push(this._transformGridTexture), t.push("u_transformGrid")), this._rasterTexture && (e.push(this._rasterTexture), t.push("u_image")), this._colormapTexture && (e.push(this._colormapTexture), t.push("u_colormap")), {
        names: t,
        textures: e
      };
    }
  }, {
    key: "onAttach",
    value: function onAttach() {
      this.invalidateTexture();
    }
  }, {
    key: "onDetach",
    value: function onDetach() {
      this.invalidateTexture();
    }
  }, {
    key: "updateTexture",
    value: function updateTexture(_ref) {
      var t = _ref.context;
      var e, r, s;
      if (!this.stage) return null == (e = this._rasterTexture) || e.dispose(), null == (r = this._transformGridTexture) || r.dispose(), null == (s = this._colormapTexture) || s.dispose(), this._rasterTexture = null, this._rasterTextureBandIds = null, this._transformGridTexture = null, void (this._colormapTexture = null);

      var i = this._isValidSource(this.source);

      i && this._colormapTextureInvalidated && (this._colormapTextureInvalidated = !1, this._updateColormapTexture(t)), this._textureInvalidated && (this._textureInvalidated = !1, this._createOrDestroyRasterTexture(t), this._rasterTexture && (i ? this.transformGrid && !this._transformGridTexture && (this._transformGridTexture = h(t, this.transformGrid)) : this._rasterTexture.setData(null)), this.suspended || (this.ready(), this.requestRender()));
    }
  }, {
    key: "_createOrDestroyRasterTexture",
    value: function _createOrDestroyRasterTexture(e) {
      var r, s;
      var i = t(this.source) ? n(this.source, this.bandIds) : null;
      if (!this._isValidSource(i)) return void (this._rasterTexture && (this._rasterTexture.dispose(), this._rasterTextureBandIds = null, this._rasterTexture = null));
      var a = !this._isBandIdschanged(this.bandIds);

      if (this._rasterTexture) {
        if (a) return;
        this._rasterTexture.dispose(), this._rasterTextureBandIds = null, this._rasterTexture = null;
      }

      this._supportsBilinearTexture = null == (r = e.capabilities.textureFloat) ? void 0 : r.textureFloatLinear;

      var o = this._getTextureSamplingMethod(this.interpolation),
          u = this.isRendereredSource || !(null != (s = e.capabilities.textureFloat) && s.textureFloat);

      this._rasterTexture = d(e, i, o, u), this._rasterTextureBandIds = this.bandIds ? _toConsumableArray(this.bandIds) : null;
    }
  }, {
    key: "_isBandIdschanged",
    value: function _isBandIdschanged(t) {
      var e = this._rasterTextureBandIds;
      return !(null == e && null == t || e && t && e.join("") === t.join(""));
    }
  }, {
    key: "_isValidSource",
    value: function _isValidSource(e) {
      var r;
      return t(e) && (null == (r = e.pixels) ? void 0 : r.length) > 0;
    }
  }, {
    key: "_getTextureSamplingMethod",
    value: function _getTextureSamplingMethod(e) {
      var _this$symbolizerParam = this.symbolizerParameters,
          r = _this$symbolizerParam.type,
          s = _this$symbolizerParam.colormap,
          i = "lut" === r || "stretch" === r && t(s);
      return !this._supportsBilinearTexture || i || "bilinear" !== e && "cubic" !== e ? "nearest" : "bilinear";
    }
  }, {
    key: "_updateColormapTexture",
    value: function _updateColormapTexture(t) {
      var e = this._colormap,
          r = this.symbolizerParameters.colormap;
      return r ? e ? r.length !== e.length || r.some(function (t, r) {
        return t !== e[r];
      }) ? (this._colormapTexture && (this._colormapTexture.dispose(), this._colormapTexture = null), this._colormapTexture = _(t, r), void (this._colormap = r)) : void 0 : (this._colormapTexture = _(t, r), void (this._colormap = r)) : (this._colormapTexture && (this._colormapTexture.dispose(), this._colormapTexture = null), void (this._colormap = null));
    }
  }]);

  return x;
}(l);

var p = /*#__PURE__*/function (_x) {
  _inherits(p, _x);

  var _super2 = _createSuper(p);

  function p() {
    _classCallCheck(this, p);

    return _super2.apply(this, arguments);
  }

  _createClass(p, [{
    key: "source",
    get: function get() {
      return this._source;
    }
  }]);

  return p;
}(x);

function c(e) {
  return t(e.source);
}

export { x as RasterBitmap, p as RasterBitmapWithSource, c as hasSource };